let initialState = {}

type initialStateType = typeof initialState

const sidebarReducer = (state = initialState, action: any): initialStateType => {

    return state
}

export default sidebarReducer;